import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/Addition/AdditionLevel.png";
import PracticeGame from "../../components/MP_PracticeGame";
import Calculator from "../../components/Calculator";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { MultiHook } from "tapable";

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

var currQuestion;

function getAnswer(calculation) {
  const calculationParts = calculation;

  if (calculationParts.length === 3) {
    const [number1, operator, number2] = calculationParts;

    switch (operator) {
      case "-":
        return parseInt(number1) - parseInt(number2);
      case "+":
        return parseInt(number1) + parseInt(number2);
      default:
        break;
    }
  }
  else {
    return 0;
  }
}

function RandomRestrictions(details, split) {
  let generation = details.split(split);
  var min = 1;
  var max = 100000;
  var cap = 0;
  for (var o = 1; o < generation.length; o++) {
    if (generation[o][0] === "<")
      max = parseInt(generation[o].substring(1));
    else if (generation[o][0] === ">")
      min = parseInt(generation[o].substring(1)) + 1;
    else if (generation[o][0] === "n")
      cap = 1;
    else if (generation[o][0] === "e")
      cap = 2;
    else if (generation[o][0] == "x")
      cap = 3;
    else if (generation[o][0] == "d")
      cap = 4;
  }
  let value = [max, min, cap];
  return value;
}

function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find, 'g'), replace);
}

//Generates a question from a default question
function GenQuestion(q) {
  let generatedCalculation = [];
  var correctAnswer = "";
  var tempAnswer = "";
  var templateAnswer = "";
  var calcs = replaceAll(q.example_question, "  ", " ").split(" ");

  console.log(q.example_question);
  console.log(calcs.length);
  generatedCalculation[0] = 0;
  //This covers all questions with one variable
  if (calcs.length === 4) {
    //N is the random number, rand will return the generation restrictions
    var N = 0;
    var rand = RandomRestrictions(calcs[3], "N");

    //Set the calculation to check results for special randoms
    generatedCalculation[0] = 0;
    generatedCalculation[1] = calcs[1];
    generatedCalculation[2] = calcs[2];

    //Only min/max set
    if (rand[2] == 0)
      N = Math.round(parseInt(rand[1]) + Math.random() * (parseInt(rand[0]) - parseInt(rand[1])));

    //Re-rolls any numbers that require exhange in the calculation
    else if (rand[2] == 1) {
      var temp = 0;
      while (N == 0 || (N.toString()[0] != temp.toString()[0] && !(N.length === 1 && temp.length === 1))) {
        N = Math.round(parseInt(rand[1]) + Math.random() * (parseInt(rand[0]) - parseInt(rand[1])));
        generatedCalculation[0] = N;
        temp = getAnswer(generatedCalculation);
      }
    }
    //Re-roll any numbers that do not require exhange in the calculation
    else if (rand[2] == 2) {
      var temp = 0;
      while (N == 0 || (N.toString()[0] != temp.toString()[0] || N.length != temp.length)) {
        N = Math.round(parseInt(rand[1]) + Math.random() * (parseInt(rand[0]) - parseInt(rand[1])));
        generatedCalculation[0] = N;
        temp = getAnswer(generatedCalculation);
      }
    }

    //Apply the generated number to the question and set the correct answer
    generatedCalculation[0] = N;
    correctAnswer = getAnswer(generatedCalculation);
  }
  //Questions with two variables that need generating
  else if (calcs.length === 5) {
    //Number bonds, generates each of the three numbers of the question
    if (calcs[2] == "N") {
      var min = 1;
      var max = 10;
      if (calcs[4] == "20") {
        min = 11;
        max = 20;
      }
      var total = Math.round(min + Math.random() * (max - min));
      var value1 = Math.round(1 + Math.random() * (total - 1));
      var value2 = total - value1;
      generatedCalculation[0] = "Complete the following number bond, " + total + ": " + value2 + ", ?";
      correctAnswer = value1;
    }
    //Two number calculations covering, large numbers, factors of 10 and decimals
    else {
      //N is first number
      var N = 0;
      var rand = RandomRestrictions(calcs[3], "N");

      //Normal number with no special parameters
      if (rand[2] == 0)
        N = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));
      //Decimal numbers
      else if (rand[2] == 4)
      {
        N = Math.round(0.1 + Math.random() * 50) / 100;
        N.toFixed(2);
      }
      //O is the second number
      var O = 0;
      var rand2 = RandomRestrictions(calcs[4], "O");

      //Normal number with no special parameters
      if (rand2[2] == 0)
        O = Math.round(rand2[1] + Math.random() * (rand2[0] - rand2[1]));
      //Power of 10
      else if (rand2[2] == 3) {
        var options = [10, 100, 1000, 10000, 100000];
        O = options[Math.floor(Math.random() * options.length - 0.01)]
      }
      //Decimal number
      else if (rand2[2] == 4)
      {
        O = Math.round(Math.random() * (N * 50)) / 100;
        O.toFixed(2);
      }
      //Set the question parameters
      generatedCalculation[0] = N;
      generatedCalculation[1] = calcs[1];
      generatedCalculation[2] = O;

      //Generate the correct answer
      if (calcs[1] == "-")
        correctAnswer = N - O;
      else
        correctAnswer = N + O;

        if (correctAnswer.toString().includes("0.")) {
          correctAnswer = correctAnswer.toFixed(2);
        }
    }
  }
  //Three part question with three generated variables
  //Liam - I have changed the array indexes to do one down as cals[7] came back undifined
  else {
    //N is variable 1
    var N = 0;
    var rand = RandomRestrictions(calcs[4], "N");
    N = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));

    //O is variable 2
    var O = 0;
    rand = RandomRestrictions(calcs[5], "O");
    O = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));

    //P is variable 3
    var P = 0;
    rand = RandomRestrictions(calcs[6], "P");
    P = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));

    //Build the question
    generatedCalculation[0] = N;
    generatedCalculation[1] = calcs[1];
    generatedCalculation[2] = O;
    generatedCalculation[3] = calcs[3];
    generatedCalculation[4] = P;

    //Set the correct answer
    correctAnswer = N + O + P;
  }

  if (q.question_key == "addsubQ34"){//missing number
    var num1 = GenerateRandom(1, 9) * 100;
    var num2 = GenerateRandom(1, 9) * 10;
    var num3 = GenerateRandom(1, 9);

    correctAnswer = num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("+");
    generatedCalculation.push("□");
    generatedCalculation.push("+");
    generatedCalculation.push(num3);
    generatedCalculation.push("=");
    generatedCalculation.push(num1+num2+num3);
  }

  if (q.question_key == "addsubQ35"){//minus 2 digit number from 3 digit number
    var num1 = GenerateRandom(1, 900);
    var num2 = GenerateRandom(1, 90);

    correctAnswer = num1-num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("-");
    generatedCalculation.push(num2);
    generatedCalculation.push("=");
  }

  if (q.question_key == "addsubQ36"){//missing number 2
    var num1 = GenerateRandom(100, 9999);
    var num2 = GenerateRandom(1, 9);

    correctAnswer = num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("-");
    generatedCalculation.push("□");
    generatedCalculation.push("=");
    generatedCalculation.push(num1-num2);
  }

  if (q.question_key == "addsubQ37"){//adding multiples of 10
    var num1 = GenerateRandom(100, 9000);
    var num2array = [10,100,1000];
    var num2 = num2array[GenerateRandom(0, num2array.length)];

    correctAnswer = num1+num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("+");
    generatedCalculation.push(num2);
    generatedCalculation.push("=");
  }

  if (q.question_key == "addsubQ38"){//adding multiples of 10
    var num1 = GenerateRandom(1001, 9000);
    var num2array = [10,100,1000];
    var num2 = num2array[GenerateRandom(0, num2array.length)];

    correctAnswer = num1-num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("-");
    generatedCalculation.push(num2);
    generatedCalculation.push("=");
  }

  //new questions here
   //new questions under here
   if (q.question_key == "addsub3Q1"){//numberbonds 10 only
    generatedCalculation = [];
      var total = 10;
      var value1 = Math.round(1 + Math.random() * (total - 1));
      var value2 = total - value1;
      
      correctAnswer = value1;
      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push("?");
      generatedCalculation.push("=");
      generatedCalculation.push(total);
  }

  if (q.question_key == "addsub3Q2"){//numberbonds 20 only
    generatedCalculation = [];
      var total = 20;
      var value1 = Math.round(1 + Math.random() * (total - 1));
      var value2 = total - value1;
      
      correctAnswer = value1;
      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push("?");
      generatedCalculation.push("=");
      generatedCalculation.push(total);
  }

  if (q.question_key == "addsub2Q4"){//Adding 1 or 2 to number that requires exchange
    generatedCalculation = [];
      
    var value1array = [9, 19, 29, 39, 49, 59, 69, 79, 89];
    var value1 = value1array[GenerateRandom(0, value1array.length)];

      var value2array = [1,2];
      var value2 = value2array[GenerateRandom(0, value2array.length)];
      
      correctAnswer = value1+value2;

      generatedCalculation.push(value1);
      generatedCalculation.push("+");
      generatedCalculation.push(value2);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q5"){//Subtracting 1, 2, 3, 4 or 5 from numbers less than 10
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,5);
    var value2 = GenerateRandom(value1+1,9);
      
      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q9"){//Adding two single digit numbers that does not require exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,5);
    var value2 = GenerateRandom(1,5);
      
      correctAnswer = value1+value2;

      generatedCalculation.push(value1);
      generatedCalculation.push("+");
      generatedCalculation.push(value2);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q2"){//Adding 1, 2, 3 or 4 to numbers that gives a sum between 11 and 20
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,4);
    var value2 = GenerateRandom(10,15);
      
      correctAnswer = value1+value2;

      generatedCalculation.push(value1);
      generatedCalculation.push("+");
      generatedCalculation.push(value2);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q3"){//Adding a single digit number to numbers less than 100 without needing to exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,8);
    var value2 = 0;

    if(value1 == 1)
    {
      value2= GenerateRandom(20,98);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89)
      {
        value2= GenerateRandom(20,98);
      }
    }
      
    if(value1 == 2)
    {
      value2= GenerateRandom(20,97);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88)
      {
        value2= GenerateRandom(20,97);
      }
    }

    if(value1 == 3)
    {
      value2= GenerateRandom(20,96);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87)
      {
        value2= GenerateRandom(20,96);
      }
    }

    if(value1 == 4)
    {
      value2= GenerateRandom(20,95);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86)
      {
        value2= GenerateRandom(20,95);
      }
    }

    if(value1 == 5)
    {
      value2= GenerateRandom(20,94);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85)
      {
        value2= GenerateRandom(20,94);
      }
    }

    if(value1 == 6)
    {
      value2= GenerateRandom(20,93);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84)
      {
        value2= GenerateRandom(20,93);
      }
    }

    if(value1 == 7)
    {
      value2= GenerateRandom(20,92);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83)
      {
        value2= GenerateRandom(20,92);
      }
    }

    if(value1 == 8)
    {
      value2= GenerateRandom(20,91);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82)
      {
        value2= GenerateRandom(20,91);
      }
    }

      correctAnswer = value1+value2;

      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q20"){//Adding a single digit number to numbers that requires exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(3,8);
    var value2 = 0;

    if(value1 == 3)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87];

         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 4)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86]

         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 5)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85]

       value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 6)
    {
     var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85
         , 24 , 34 , 44 , 54 , 64 , 74 , 84]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 7)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85
         , 24 , 34 , 44 , 54 , 64 , 74 , 84
         , 23 , 33 , 43 , 53 , 63 , 73 , 83]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 8)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85
         , 24 , 34 , 44 , 54 , 64 , 74 , 84
         , 23 , 33 , 43 , 53 , 63 , 73 , 83
         , 22 , 32 , 42 , 52 , 62 , 72 , 82]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

      correctAnswer = value1+value2;

      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q6"){ //Subtracting 1, 2, 3 or 4 from numbers more than 10 and less than 19
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,4);
    var value2 = GenerateRandom(10,18);
      
      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q15"){ //Subtracting a single digit number from numbers less than 100, without needing to exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(2,8);
    var value2 = 0;
 
    if(value1 == 2)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 3)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 4)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 5)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 6)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85 || value2 == 95)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 7)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85 || value2 == 95
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86 || value2 == 96)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 8)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85 || value2 == 95
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86 || value2 == 96
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87 || value2 == 97)
      {
        value2= GenerateRandom(20,99);
      }
    }

      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
  }

  if (q.question_key == "addsub2Q16"){ //Subtracting a single digit number from numbers less than 100 that need to exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(2,8);
    var value2 = 0;
 
    if(value1 == 2)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 3)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 4)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 5)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 6)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94
         ,25 ,35 ,45 ,55 ,65 ,75 ,85 ,95]
      
      value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 7)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94
         ,25 ,35 ,45 ,55 ,65 ,75 ,85 ,95
         ,26 ,36 ,46 ,56 ,66 ,76 ,86 ,96]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 8)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94
         ,25 ,35 ,45 ,55 ,65 ,75 ,85 ,95
         ,26 ,36 ,46 ,56 ,66 ,76 ,86 ,96
         ,27 ,37 ,47 ,57 ,67 ,77 ,87 ,97]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
  }

  let temp2 = [];
  temp2[0] = generatedCalculation;
  temp2[1] = correctAnswer;
  //Creates object to return
  let questionObj = {
    question: temp2,
    answers: correctAnswer,
    correct: correctAnswer,
    topic_id: q.topic_id
  };
  return questionObj;
}

export default function Multiplayer({ ...props }) {
  console.log("addition");
  const game = props.game;
  console.log(props);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState([,]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  //const [realQuestions, setRealQuestions] = useState();
  const [workAround, setWorkAround] = useState(false);
  const [place, setPlace] = useState(0);

  //this checks if correct and then goes to the next question
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      console.log(currQuestion.correct + " vs " + value);
      //correct answer
      
      var decString = "0." + value;

      var curCorrect = currQuestion.correct;
      if (curCorrect[3] == "0")
      {
        curCorrect = parseFloat(curCorrect).toFixed(1);
        decString =  parseFloat(decString).toFixed(1);
      }
      
      if ((currQuestion.correct.toString().includes("0.") && curCorrect == decString) || (currQuestion.correct == value)) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);
        if (multiplier != 0 && multiplier != undefined)
          props.SubmitScore(multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
          props.SubmitScore(-10)
        } else {
          setCombo(0);
        }

        if (currQuestion.correct.toString().includes("0."))
        {
        let result = {
          question: currQuestion.question[0].join(" "),
          correct: currQuestion.correct,
          incorrect: "0." + value
        };
        setFeedback([...feedback, result]);
      }
      else
      {
        let result = {
          question: currQuestion.question[0].join(" "),
          correct: currQuestion.correct,
          incorrect: value
        };
        setFeedback([...feedback, result]);
      }
      }

      if (callback) {
        await callback(isCorrect, currQuestion[1]).then(() => {
          setCurrentQuestion(newQuestion());
        });
      } else {
        setCurrentQuestion(newQuestion());
      }
    }
  }

  function GetListOfPositions() {
    //order the scores
    //console.log(props);
    //var web = props.parent.getwebrtc();
    var web = props.ReturnScores();
    var webcopy = JSON.parse(JSON.stringify(web));
    // console.log(webcopy);
    //then order the scores in descending order
    //display them as a list
    webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
    //console.log(webcopy);
    //replace yourname with YOU
    for (let i = 0; i < webcopy.length; i++) {
      if (webcopy[i].username == props.details.username)
        webcopy[i].username = "You"
    }
    var scoreText = [];
    for (let i = 0; i < webcopy.length; i++) {
      let temptext = webcopy[i].username + ": " + webcopy[i].score
      scoreText.push(temptext);
    }
    // console.log(scoreText);
    const listItems = scoreText.map((i) =>
      <li>{i}</li>
    );

    return listItems;
  }

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    var difficulty = Math.floor(Math.random() * questions.length);
    var questionNum = Math.floor(Math.random() * questions[difficulty].length)
    currQuestion = GenQuestion(questions[difficulty][questionNum]);;
    console.log(questions[difficulty][questionNum])
    console.log(currQuestion);
    setCurrentQuestion(currQuestion);
    return currQuestion;
  }

  function GetPlace() {
    var position = 0;
    //order the scores
    var web = props.ReturnScores();
    var webcopy = JSON.parse(JSON.stringify(web));
    //then order the scores in descending order
    //display them as a list
    webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
    console.log(webcopy);
    //gets your position in the list
    for (let i = 0; i < webcopy.length; i++) {
      if (webcopy[i].username == props.details.username) {
        setPlace(i + 1);
        position = i + 1;
      }

    }
    console.log(place);
    console.log(position);
    return position;
  }

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions)
      setCurrentQuestion(newQuestion())
    }
  }, [questions]);

  function ComboImage(){
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
        comboNum = 4;
    var imageName = props.game.animation_path + "/combo"+comboNum+".gif";
     //return <img src= {{imageName}} style={{position:"relative"}}></img>
     if (combo < 3){
       return <img style={{position: "absolute",top:"70%",right:"15%"}} src={require("../../assets/"+imageName)}></img>
     }else{
      return <img style={{position: "absolute",top:"56%",right:"5%"}} src={require("../../assets/"+imageName)}></img>
     }
     
}


  return (
    <PracticeGame
      parent={props}
      loading={!questions}
      correct={correctQuestions}
      incorrect={incorrectQuestions}
      score={score}
      onBack={() => props.onBack()}
      defaultTimer={60}
      restart={() => {
        setCombo(0);
        setScore(0);
        setCorrectQuestions([]);
        setIncorrectQuestions([]);
      }}
      feedback={feedback}
      homework_id={props.homework_id}
      getplace={() => GetPlace()}
    >
      <Body>
        <FormContent style={{ right: "100px", position: "relative", top: "0px", width: "200px", height: "50%" }}>
          <br></br>
          {GetListOfPositions()}
        </FormContent>
        <div>{currQuestion !== undefined ? (

          <Calculator
            currentQuestion={currQuestion.question}
            onSubmitted={checkResult}
          />

        ) : <h1>help</h1>}
        </div>
        <Combo>
          <span style={{ fontSize: "50px" }}>{combo}</span>
          <span style={{ fontSize: "20px" }}>COMBO</span>
        </Combo>
      </Body>
      {ComboImage()}
    </PracticeGame>
  );
}

const Body = styled.div`
    width: 100%;
    height: 100%;
    background-image: url(${background});
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 40px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 2px solid #673b8b;
  border-radius: 1em;
  font-size: 2em;

  h1 {
    color: #673b8b;
    font-size: 4em;
    margin: 0.25em;
  }


`;
